import { DefaultOptions, QueryClient } from '@tanstack/react-query'

import { isClientError } from './api'

const queryConfig: DefaultOptions = {
  queries: {
    retry: (failureCount, error) => {
      // Don't retry for client errors
      if (isClientError(error)) {
        return false
      }
      return failureCount < 3
    },
  },
}

export const queryClient = new QueryClient({ defaultOptions: queryConfig })
